import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Email from "../../components/public/SignUp/Email";
import Password from "../../components/public/SignUp/Password";
import Name from "../../components/public/SignUp/Name";
import Welcome from "../../components/public/SignUp/Welcome";
import Industry from "../../components/public/SignUp/CompanyProfile/industry";
import { CompanyAddress } from "../../components/public/SignUp/CompanyProfile/CompanyAddress";
import { ContactInformation } from "../../components/public/SignUp/CompanyProfile/ContactInformation";
import { TradeLicense } from "../../components/public/SignUp/CompanyProfile/TradeLicense";
import { AuthorizedSignatory } from "../../components/public/SignUp/CompanyProfile/AuthorizedSignatory";
import SearchCompany from "../../components/public/SignUp/CompanyProfile/SearchCompany";
import Verification from "../../components/public/SignUp/Verification";
import { AuthorizedLetter } from "../../components/public/SignUp/CompanyProfile/AuthorizationLetter";
import PlatformOptions from "../../components/public/SignUp/PlatformOptions";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIndividualCompanyMutation, } from '../../store/Company/companyApiSlice'

const SignUp = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const isArticle = params.get('app') === "article";
  const slug = params.get('slug');
  const inviteCode = params.get('invite_code');
  const haveEmail = params.get('email')
  const { state } = useLocation();
  const [step, setStep] = useState(
    state?.redirectToStep ? state?.redirectToStep : 1
  );
  const [individualCompany] = useIndividualCompanyMutation();

  const [email, setEmail] = useState("");
  const [emailReady, setEmailReady] = useState(false);
  const [waitingForEmail, setWaitingForEmail] = useState(true);
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [status, setSuccessStatus] = useState(false);
  const handleEmailNext = (email, code) => {
    setEmail(email);
    setCode(code);
    setStep(2);

  };
  // const { token, userInfo } = useSelector((state) => state.auth);
  // const {
  //   searchQuery,
  //   searchResults,
  //   worldBoxToken,
  //   companySelectedByUser,
  //   searchCount,
  // } = useSelector((state) => state.search);

  useEffect(() => {
    function onMessage(e) {
      if (e.origin !== process.env.REACT_APP_K_HUB_URL) return;

      if (e.data.type === "PREFILL_EMAIL") {
        setEmail(e.data.email);
        setEmailReady(true);
        setWaitingForEmail(false);
      }
    }

    window.addEventListener("message", onMessage);

    // tell parent we're ready
    window.opener?.postMessage(
      { type: "SIGNUP_READY" },
      process.env.REACT_APP_K_HUB_URL
    );

    return () => window.removeEventListener("message", onMessage);
  }, []);



  useEffect(() => {
    if (inviteCode) {
      localStorage.setItem('invite_code', inviteCode);
    }
  }, [inviteCode])

  const handlePasswordBack = () => {
    setStep(1);
  };

  const handleVerifyNext = () => {
    setStep(3);
  };
  const plansInformation = [
    {
      title: "Pay-as-you-go",
      mode: "one-time",
      slug: "pay-as-you-go",
      subsCharge: 79,
      talkToSales: true,
      Features: [
        "1 profile views for 1 month",
        "full profile access for 1 month.",
      ],
    },
    {
      title: "Basic",
      mode: "subscription",
      slug: "basic",
      subsCharge: 195,
      talkToSales: true,
      Features: [
        "3 profile views for 1 month",
        "full profile access for 1 month",
      ],
    },
    {
      subsType: "Recommended",
      title: "Pro",
      slug: "pro",
      mode: "subscription",
      subsCharge: 275,
      talkToSales: true,
      Features: [
        "5 profile views per month",
        "full profile access for 1 month",
      ],
    },
    {
      title: "Premium",
      mode: "subscription",
      slug: "premium",
      subsCharge: 500,
      talkToSales: true,
      Features: [
        "10 profile views per month",
        "full profile access for 1 month",
      ],
    },
  ];
  const handlePasswordNext = (password) => {
    setPassword(password);
    const lastVisited = localStorage.getItem('lastVisited');
    const slug = localStorage.getItem('slug');
    if (slug && lastVisited == "/plans") {
      let plan = plansInformation.filter((item) => item.slug === slug);
      const companyDataString = localStorage.getItem("payasyougoCompanyID");
      window.scrollTo(0, 0);
      navigate("/plans/paymentdetails", {
        state: {
          planDetails: plan[0],
          company_id: JSON.parse(JSON.stringify(companyDataString)),
        },
      });
    }
    else if (lastVisited) {
      navigate(`${lastVisited}`);
    } else {
      setStep(4);
    }
  };

  const handleNameNext = (status, manage) => {
    setSuccessStatus(status);
    if (manage === "manage") {
      setStep(12);
    } else {
      setStep(5);
    }
  };

  const handleOptionNext = (manage) => {
    if (manage === "manage") {
      setStep(6);
    } else {
      setStep(5);
    }
  };

  const handleWelcome = () => {
    navigate("/");
  };
  const handleWelcome1 = () => {
    navigate("/dashboard/request");
  };

  const handleNameBack = () => {
    setStep(3);
  };

  const handleSearchCompanyNext = () => {
    setStep(10);
  };

  const handleSearchCompanyBack = () => {
    const lastVisited = localStorage.getItem('lastVisited');
    if (lastVisited) {
      localStorage.removeItem('lastVisited');
      navigate(`${lastVisited}`);
    } else {
      setStep(4);
    }
  };

  const handleSectorBack = () => {
    setStep(6);
  };

  const handleIndustryNext = () => {
    setStep(8);
  };

  const handleCompanyAddressNext = () => {
    setStep(9);
  };

  const handleCompanyAddressBack = () => {
    setStep(7);
  };

  const handleContactInfoNext = () => {
    setStep(10);
  };

  const handleContactInfoPrev = () => {
    setStep(8);
  };

  const handleTradeLicenseNext = () => {
    setStep(11);
  };

  const handleTradeBack = () => {
    setStep(6);
  };

  const handleAuthorizedSignatoryNext = () => {
    setStep(7);
  };

  const handleAuthorizedSignatoryBack = () => {
    setStep(10);
  };

  const handleAuthorizedLetterNext = async (companyID, new_company) => {
    if (new_company == 0) {
      setStep(5);
    } else {
      setStep(13);
    }
  };

  const handleAuthorizedLetterBack = () => {
    setStep(11);
  };
  if (waitingForEmail && haveEmail) {
    return (
      <div style={{ height: "100vh", display: "grid", placeItems: "center" }}>
        <p>Preparing signup…</p>
      </div>
    );
  }

  switch (step) {

    case 1:
      return <Email onNext={handleEmailNext} onEmail={email} />;
    case 2:
      return (
        <Verification
          onNext={handleVerifyNext}
          onEmail={email}
          onPrev={handlePasswordBack}
          verificationCode={code}
        />
      );
    case 3:
      return <Password email={email} onNext={handlePasswordNext} isArticle={isArticle} slug={slug} />;
    case 4:
      return <PlatformOptions onNext={handleOptionNext} />;
    case 14:
      return (
        <Name
          email={email}
          password={password}
          onNext={handleNameNext}
          onPrev={handleNameBack}
        />
      );
    case 5:
      return <Welcome status={status} onNext={handleWelcome} step="onboard" />;
    case 6:
      return (
        <SearchCompany
          onNext={handleSearchCompanyNext}
          onPrev={handleSearchCompanyBack}
        />
      );
    case 7:
      return <Industry onNext={handleIndustryNext} onPrev={handleSectorBack} />;
    case 8:
      return (
        <CompanyAddress
          onNext={handleCompanyAddressNext}
          onPrev={handleCompanyAddressBack}
        />
      );
    case 9:
      return (
        <ContactInformation
          onNext={handleAuthorizedLetterNext}
          onPrev={handleContactInfoPrev}
        />
      );
    case 10:
      return (
        <TradeLicense
          onNext={handleTradeLicenseNext}
          onPrev={handleTradeBack}
        />
      );
    case 11:
      return (
        <AuthorizedSignatory
          onNext={handleAuthorizedSignatoryNext}
          onPrev={handleAuthorizedSignatoryBack}
        />
      );
    case 12:
      return (
        <AuthorizedLetter
          onNext={handleAuthorizedLetterNext}
          onPrev={handleAuthorizedLetterBack}
        />
      );
    case 13:
      return <Welcome status={status} onNext={handleWelcome1} step="newcompany" />;
    default:
      return null;
  }
};

export default SignUp;
